"use strict";

var _send = _interopRequireDefault(require("./send"));

var _headers = _interopRequireDefault(require("./headers"));

var _nodes = _interopRequireDefault(require("../../model/nodes"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Gets market information from Poloniex api
 *
 * @return {object} - A MarketInfo object
 */
var xem = function xem() {
  // Configure the request
  var options = {
    url: _nodes["default"].marketInfo,
    method: 'GET',
    headers: _headers["default"].urlEncoded,
    qs: {
      'command': 'returnTicker'
    }
  }; // Send the request

  return (0, _send["default"])(options);
};
/**
 * Gets BTC price from blockchain.info API
 *
 * @return {object} - A MarketInfo object
 */


var btc = function btc() {
  // Configure the request
  var options = {
    url: _nodes["default"].btcPrice,
    method: 'GET',
    headers: _headers["default"].urlEncoded,
    qs: {
      'cors': true
    }
  }; // Send the request

  return (0, _send["default"])(options);
};

module.exports = {
  xem: xem,
  btc: btc
};
//# sourceMappingURL=market.js.map